export const USER_COVER = "https://lh3.googleusercontent.com/pw/AP1GczPAbDoVLRhAaQki58tzXmyKBNDZzZbcAPgjfPJ8VfNH5FI-aGGpHfwSYYJvtpI7Vsp9A5hEY3nJjExqsY4WU9xVvo6MLblM0j0Vi6f5BMn3jYf4ECGc=w2000";
